import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=3cdf4648&scoped=true"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=3cdf4648&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdf4648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cdf4648')) {
      api.createRecord('3cdf4648', component.options)
    } else {
      api.reload('3cdf4648', component.options)
    }
    module.hot.accept("./BillDetail.vue?vue&type=template&id=3cdf4648&scoped=true", function () {
      api.rerender('3cdf4648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/stock-check/BillDetail.vue"
export default component.exports